<app-dialog-title
    [title]="'meter.manage.link_title' | translate"
    (close)="close()">
</app-dialog-title>

<mat-dialog-content>
    <div class="form-section">
        <h4 class="section-label">{{ 'meter.manage.link_section_meter' | translate }}</h4>

        <div class="field-row">
            <div class="field-group">
                <label class="field-label">{{ 'meter.manage.col_meter_id' | translate }} *</label>
                <input type="text" class="field-input" [(ngModel)]="nodeId"
                       [placeholder]="'e.g. 93236586'">
            </div>

            <div class="field-group">
                <label class="field-label">{{ 'meter.manage.col_type' | translate }}</label>
                <select class="field-input" [(ngModel)]="nodeType">
                    <option *ngFor="let t of nodeTypeOptions" [value]="t">{{ t }}</option>
                </select>
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-label">{{ 'meter.manage.col_address' | translate }}</h4>

        <div class="field-row">
            <div class="field-group flex-2">
                <label class="field-label">{{ 'meter.manage.link_street' | translate }} *</label>
                <input type="text" class="field-input" [(ngModel)]="street"
                       [placeholder]="'e.g. 123 Brebeuf Street'">
            </div>

            <div class="field-group">
                <label class="field-label">{{ 'meter.manage.link_unit' | translate }}</label>
                <input type="text" class="field-input" [(ngModel)]="unit"
                       [placeholder]="'e.g. A'">
            </div>
        </div>

        <div class="field-row">
            <div class="field-group">
                <label class="field-label">{{ 'meter.manage.link_city' | translate }} *</label>
                <input type="text" class="field-input" [(ngModel)]="city"
                       [placeholder]="'e.g. Casselman'">
            </div>

            <div class="field-group">
                <label class="field-label">{{ 'meter.manage.link_postal_code' | translate }} *</label>
                <input type="text" class="field-input" [(ngModel)]="postCode"
                       [placeholder]="'e.g. K0A 1M0'">
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-label">{{ 'meter.manage.link_section_user' | translate }}</h4>

        <div class="field-group">
            <label class="field-label">{{ 'meter.manage.link_search_user' | translate }} *</label>
            <div class="user-search-container">
                <input type="text" class="field-input"
                       #userSearchInput
                       [value]="userSearchTerm"
                       (input)="onUserSearch(userSearchInput.value)"
                       [placeholder]="'meter.manage.link_user_placeholder' | translate">

                <div class="user-results" *ngIf="userResults.length > 0 && !selectedUser">
                    <div class="user-result-item"
                         *ngFor="let user of userResults"
                         (click)="selectUser(user)">
                        <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
                        <span class="user-email">{{ user.email }}</span>
                    </div>
                </div>

                <div class="user-searching" *ngIf="searchingUsers">
                    <mat-spinner diameter="16"></mat-spinner>
                </div>
            </div>

            <div class="selected-user" *ngIf="selectedUser">
                <mat-icon>person</mat-icon>
                <span>{{ selectedUser.firstName }} {{ selectedUser.lastName }} ({{ selectedUser.email }})</span>
            </div>
        </div>
    </div>

    <div class="error-message" *ngIf="error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error | translate }}</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <button class="cancel-button" (click)="close()">{{ 'common.cancel' | translate }}</button>
    <button class="submit-button" [disabled]="!isValid || submitting" (click)="onSubmit()">
        <mat-spinner *ngIf="submitting" diameter="16"></mat-spinner>
        <span *ngIf="!submitting">{{ 'meter.manage.link_submit' | translate }}</span>
        <span *ngIf="submitting">{{ 'meter.manage.link_submitting' | translate }}</span>
    </button>
</mat-dialog-actions>
